import React, { useCallback, useState } from 'react'

import { useTranslate } from 'react-redux-multilingual/lib/context'

import { getFileFromEvent } from '../../../../../../../helpers'

import { Grid, Typography } from '@material-ui/core'

import FileInput from '../../../../../../UI/Forms/FileInput/FileInput'
import InputGroup from '../../../../../../UI/Forms/InputGroup/InputGroup'
import Button from '../../../../../../UI/Button/Button'

const FeedbackInput = ({ onFeedbackSubmit, loading }) => {
  const translate = useTranslate()
  const [touched, setTouched] = useState(false)
  const [commentText, setCommentText] = useState('')
  const [commentFile, setCommentFile] = useState(null)

  const onCommentTextChangeHandler = useCallback(e => {
    setCommentText(e.target.value)
    setTouched(true)
  }, [])

  const onFileChangedHandler = useCallback(e => {
    const file = getFileFromEvent(e)
    setCommentFile(file[0])
  }, [])

  const onSubmitHandler = useCallback(() => {
    const commentPayload = {
      file: commentFile,
      message: commentText
    }

    onFeedbackSubmit(commentPayload)
  }, [commentText, commentFile, onFeedbackSubmit])

  const commonProps = { disabled: loading }

  const inputIsInvalid = commentText.length < 100

  return (
    <Grid container spacing={1} justify={'flex-end'}>
      <Grid item xs={12} md={8}>
        <InputGroup
          label={'Comment'}
          variant={'outlined'}
          changed={onCommentTextChangeHandler}
          inputValue={commentText}
          inputType={'input'}
          configs={{ size: 'small', multiline: true }}
          invalid={inputIsInvalid}
          validations={true}
          touched={touched}
          validationError={translate('commentIsRequiredMin100')}
          noMargin
          {...commonProps}
        />
        <Typography component={'div'} variant={'caption'}>
          {commentFile?.name ?? null}
        </Typography>
      </Grid>
      <Grid item xs={3} md={2}>
        <FileInput
          selected={commentFile}
          variant={'button'}
          changed={onFileChangedHandler}
          {...commonProps}
        />
      </Grid>
      <Grid item xs={3} md={2}>
        <Button color={'primary'} clicked={onSubmitHandler} disabled={inputIsInvalid || loading}>
          {translate('reply')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default FeedbackInput
